export default {
  minCosts: {
    data: null,
    loading: false,
    error: null
  }
}
